import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PosPromoOtoResellerPage } from './pos-promo-oto-reseller.page';

const routes: Routes = [
  {
    path: '',
    component: PosPromoOtoResellerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PosPromoOtoResellerPageRoutingModule {}
